module.exports = __webpack_public_path__ + "static/media/afiche1920.9947e062.webp";